import { doRequest } from '../../../services/requests/Base'

export const sendRequestMoreEmailRequest = async (): Promise<void> => {
  await doRequest('v2/emails/requestMore', 'GET')
}
